import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom'

import SwiperCore, { A11y } from 'swiper';
SwiperCore.use([A11y]);

// Load Google Analytics only in production
if (process.env.REACT_APP_ISPRODUCTION === 'true') {
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-D416MPDMWZ';
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-D416MPDMWZ');
  `;
  document.head.appendChild(script2);
}




ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('topRoot')
);

reportWebVitals();
